import { Box, Typography } from "@mui/material";
import React from "react";

const data = [
  {
    title: "What Will Change In Your Sales Organisation?",
    desc: "",
  },
  {
    title: "What Will Change In Your Sales Organisation?",
    desc: "",
  },
  {
    title: "The Framework That Creates Predictable Sales Momentum",
    desc: "",
  },
  {
    title: "Why Revenue Feels Random (And How To Fix It)",
    desc: "",
  },
  {
    title: "How To Build A Structured Sales System That Scales Consistently",
    desc: "",
  },
];

const WhatULearn=() =>{
  return (
    <Box
      sx={{
        background: "#000",
        py: { xs: 6, md: 10 },
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "1100px",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        {/* LEFT IMAGE */}
        <Box
          sx={{
            width: { xs: "100%", md: "32%" },
            height: { xs: "550px", md: "600px" },
            position: "relative",
            backgroundImage:
              "url(https://dprstorage.b-cdn.net/RW/crw.png)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* BLACK OVERLAY */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background: "rgba(0,0,0,0.35)",
            }}
          />
        </Box>

        {/* RIGHT CONTENT */}
        <Box
          sx={{
            width: { xs: "auto", md: "68%" },
            background: "#0b2d4a",
            px: { xs: 4, md: 8 },
            py: { xs: 6, md: 6 },
            color: "#fff",
          }}
        >
          {/* TITLE */}
          <Box sx={{ mb: 6 }}>
            <Box
              component="span"
              sx={{
                color: "#fff",
                fontSize: 24,
                fontWeight: 700,
                letterSpacing: 2,
                mr: 1,
              }}
            >
              What You Will Learn In
            </Box>

            <Typography
              variant="h3"
              sx={{
                background:
                  "linear-gradient(90deg, #ffffff 0%, #d4af37 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                position: "relative",
                display: "inline-block",
                fontWeight: 700,

                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: "0px",
                  left: 0,
                  width: "100%",
                  height: "10px",
                  background: "rgb(177 177 177 / 50%)",
                  //   zIndex: -1,
                  borderRadius: "4px",
                },
              }}
            >
               4 Hours
            </Typography>
          </Box>

          {data.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                // mb: 4, // reduced gap
              }}
            >
              {/* NUMBER + LINE */}
              <Box
                sx={{
                  width: 60,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  mr: 3,
                }}
              >
                {/* NUMBER */}
                <Box
                  sx={{
                    width: 50,
                    height: 50,
                    borderRadius: "50%",
                    background: "#d4af37 ",
                    color: "#000",
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 2,
                  }}
                >
                  {index + 1}
                </Box>

                {/* CONNECTOR */}
                {index !== data.length - 1 && (
                  <Box
                    sx={{
                      width: "2px",
                      height: "60px",
                      background: "#f4a300",
                      mt: 0,
                    }}
                  />
                )}
              </Box>

              {/* TEXT */}
              <Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    mb: 1,
                    color: 'white'
                  }}
                >
                  {item.title}
                </Typography>

                <Typography
                  sx={{
                    color: "#f4a300",
                    lineHeight: 1.7,
                    maxWidth: "480px",
                  }}
                >
                  {item.desc}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default WhatULearn;